import { render, staticRenderFns } from "./DeviceAssignment.vue?vue&type=template&id=0fdb2ae6"
import script from "./DeviceAssignment.vue?vue&type=script&lang=js"
export * from "./DeviceAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports